import { render, staticRenderFns } from "./SellLineTip.vue?vue&type=template&id=c454d120&scoped=true"
import script from "./SellLineTip.vue?vue&type=script&lang=js"
export * from "./SellLineTip.vue?vue&type=script&lang=js"
import style0 from "./SellLineTip.vue?vue&type=style&index=0&id=c454d120&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c454d120",
  null
  
)

export default component.exports